import { render } from "./ConfirmMyAccount.vue?vue&type=template&id=5af621a9&ts=true"
import script from "./ConfirmMyAccount.vue?vue&type=script&lang=ts"
export * from "./ConfirmMyAccount.vue?vue&type=script&lang=ts"

import "./ConfirmMyAccount.vue?vue&type=style&index=0&id=5af621a9&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__